// This file is auto-generated by @oracle/oraclejet-icu-l10n from src/resources/icu/bundle.json
// and should not be edited by hand. Update the JSON file and rerun the build to regenerate this content.

const bundle = {
  accAnnounceMovedKey: (p: { itemKey: string; position: string; referenceKey: string }) =>
    'Presunuté ' + p['itemKey'] + ' ' + p['position'] + ' ' + p['referenceKey'] + '.',
  accButtonProgressComplete: (p: { label: string }) => 'Akcia ' + p['label'] + ' bola dokončená',
  accButtonProgressStatus: (p: { label: string }) => 'Prebieha akcia ' + p['label'],
  accColorPalette: () => 'Paleta farieb',
  accColorSwatch: () => 'Vzorkovnica farieb',
  accCommandKey: () => 'Príkaz',
  accContextMenuLabel: () => 'akcie',
  accControlKey: () => 'Zavrieť',
  accPositionAfter: () => 'po',
  accPositionBefore: () => 'pred',
  accReorderInstructions: (p: { keyPressed: string }) =>
    'Stlačte a podržte klávesy ' +
    p['keyPressed'] +
    ' a Shift a potom pomocou klávesov so šípkami zmeňte poradie.',
  calendarDateConverter_parseError: (p: { dateExample: string }) =>
    'Zadajte napríklad takýto dátum dokončenia: ' + p['dateExample'] + '.',
  calendarMonthConverter_parseError: (p: { dateExample: string }) =>
    'Zadajte napríklad takýto mesiac a rok: ' + p['dateExample'] + '.',
  chart_labelDataLabel: () => 'Návesť',
  chart_labelGroup: () => 'Skupina',
  chart_labelSeries: () => 'Séria',
  chart_labelValue: () => 'Hodnota',
  chart_labelWidthWeight: () => 'Z',
  chart_labelX: () => 'X',
  chart_labelY: () => 'Y',
  checkboxSet_requiredMessageDetail: () => 'Vyberte hodnotu.',
  checkbox_helpForCheckbox: () => 'Pomoc pre začiarkavacie políčko',
  checkbox_requiredMessageDetail: () => 'Vyberte hodnotu.',
  checkbox_selected: () => 'Políčko je začiarknuté',
  checkbox_unselected: () => 'Políčko nie je začiarknuté',
  close: () => 'Zavrieť',
  collection_apply: () => 'Použiť',
  collection_cancel: () => 'Zrušiť',
  collection_loaded: () => 'Načítané',
  collection_loading: () => 'Zavádza sa',
  collection_noData: () => 'Žiadne dáta na zobrazenie.',
  collection_pixels: () => 'px',
  collection_resizeColumnDialog: () => 'Zmeniť veľkosť stĺpca',
  collection_resizeColumnMenu: () => 'Zmeniť veľkosť stĺpca...',
  collection_resizeMessageDetail: (p: { MIN: string; MAX: string }) =>
    'Zadajte číslo medzi ' + p['MIN'] + ' a ' + p['MAX'] + '.',
  collection_selectAllRows: () => 'Vybrať všetky riadky',
  collection_selectRow: (p: { ROW_NAME: string }) => 'Vybrať riadok ' + p['ROW_NAME'],
  collection_sortAscendingSubMenu: () => 'Vzostupne',
  collection_sortColumnMenu: () => 'Triediť stĺpec',
  collection_sortDescendingSubMenu: () => 'Zostupne',
  collection_sortDisabled: () => 'Nie je možné triediť',
  collection_sortEnabled: () => 'Je možné triediť',
  collection_width: () => 'Šírka',
  colorPicker_label: () => 'Výber farby',
  confirmation: () => 'Potvrdenie',
  datePicker_currentDate: () => 'Aktuálny dátum',
  datePicker_goToToday: () => 'Prejsť na dnešný deň',
  datePicker_label: () => 'Výber dátumu',
  datePicker_month: () => 'Mesiac',
  datePicker_months: () => 'Mesiace',
  datePicker_next: () => 'Nasledujúci',
  datePicker_nextDecade: () => 'Nasledujúca dekáda',
  datePicker_nextMonth: () => 'Nasledujúci mesiac',
  datePicker_prev: () => 'Predchádzajúci',
  datePicker_prevDecade: () => 'Predchádzajúca dekáda',
  datePicker_prevMonth: () => 'Predchádzajúci mesiac',
  datePicker_restricted: () => 'Obmedzené',
  datePicker_selected: () => 'Vybrané',
  datePicker_today: () => 'Dnes',
  datePicker_weekNum: (p: { NUM: string }) => p['NUM'] + '. týždeň',
  datePicker_weekNumColLabel: () => 'Číslo týždňa',
  datePicker_year: () => 'Rok',
  datePicker_years: () => 'Roky',
  diagram_promotedLink: () => '1 prepojenie',
  diagram_promotedLinkAriaDesc: () => 'Nepriame',
  diagram_promotedLinks: (p: { num_links: string }) => 'Prepojenia: ' + p['num_links'],
  error: () => 'Chyba',
  expandableList_expandCollapseInstructionText: () =>
    'Na rozbalenie a zbalenie použite klávesy so šípkami',
  expandableList_groupCollapse: () => 'Zbalené',
  expandableList_groupExpand: () => 'Rozbalené',
  filePicker_addFiles: () => 'Pridať súbory',
  filePicker_dropzonePrimaryText: () => 'Presunutie myšou',
  filePicker_dropzoneSecondaryText: () => 'Vyberte súbor alebo sem presuňte nejaký súbor',
  filePicker_dropzoneSecondaryTextMultiple: () => 'Vyberte súbory alebo sem presuňte nejaké súbory',
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    'Súbory typu ' + p['fileTypes'] + ' nie je možné nahrať',
  filePicker_singleFileUploadError: () => 'Súbory nahrávajte po jednom',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    'Súbory typu ' + p['fileType'] + ' nie je možné nahrať',
  filePicker_unknownFileTypeUploadError: () => 'neznáme',
  formControl_clear: () => 'Vymazať',
  formControl_day: () => 'Deň',
  formControl_empty_segment: () => 'Prázdne',
  formControl_helpAvailable: () => 'K dispozícii je pomoc',
  formControl_hide: () => 'Skryť',
  formControl_hour: () => 'Hodina',
  formControl_limitReached: (p: { CHARACTER_LIMIT: number }) =>
    'Dosiahli ste limit ' +
    ((
      {
        one: new Intl.NumberFormat('sk').format(p['CHARACTER_LIMIT']) + ' znaku',
        few: new Intl.NumberFormat('sk').format(p['CHARACTER_LIMIT']) + ' znakov',
        many: new Intl.NumberFormat('sk').format(p['CHARACTER_LIMIT']) + ' znaku'
      } as Partial<Record<Intl.LDMLPluralRule, string>>
    )[new Intl.PluralRules('sk').select(p['CHARACTER_LIMIT'])] ||
      new Intl.NumberFormat('sk').format(p['CHARACTER_LIMIT']) + ' znakov') +
    '.',
  formControl_loading: () => 'Zavádza sa',
  formControl_maxLength: (p: { MAX_LENGTH: string }) =>
    'Môžete zadať maximálne tento počet znakov: ' + p['MAX_LENGTH'] + '.',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    'Maximálna dĺžka ' + p['MAX_LENGTH'] + ' bola prekročená.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    'Počet zostávajúcich znakov: ' + p['CHARACTER_COUNT'] + '.',
  formControl_millisecond: () => 'Milisekunda',
  formControl_minute: () => 'Minúta',
  formControl_month: () => 'Mesiac',
  formControl_readOnly: () => 'Len na čítanie',
  formControl_requiredMessageDetail: () => 'Zadajte hodnotu.',
  formControl_second: () => 'Sekunda',
  formControl_selectionExactMessageDetail: (p: { n: string }) =>
    'Vyberte tento počet hodnôt: ' + p['n'] + '.',
  formControl_selectionOverflowMessageDetail: (p: { max: string }) =>
    'Dosiahli ste maximálny limit výberu ' + p['max'] + '.',
  formControl_selectionRangeMessageDetail: (p: { min: string; max: string }) =>
    'Vyberte ' + p['min'] + ' až ' + p['max'] + ' hodnôt.',
  formControl_selectionUnderflowMessageDetail: (p: { min: string }) =>
    'Vyberte aspoň ' + p['min'] + ' hodnoty.',
  formControl_show: () => 'Zobraziť',
  formControl_year: () => 'Rok',
  gantt_labelDate: () => 'Dátum',
  gantt_labelEnd: () => 'Koniec',
  gantt_labelLabel: () => 'Návesť',
  gantt_labelRow: () => 'Riadok',
  gantt_labelStart: () => 'Začiatok',
  indexer_disabledLabel: (p: { SECTION: string }) =>
    p['SECTION'] + '. Nenašla sa žiadna zodpovedajúca sekcia.',
  indexer_keyboardInstructionText: () => 'Stlačte kláves Enter a vyberte hodnotu.',
  indexer_othersLabel: () => '#',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    'Medzi ' + p['FROM_SECTION'] + ' a ' + p['TO_SECTION'] + '.',
  indexer_touchInstructionText: () =>
    'Dvakrát ťuknite a podržte na zadanie režimu gest, potom posunutím nahor alebo nadol upravte hodnotu.',
  info: () => 'Informácie',
  inputColor_selectColor: () => 'Vyberte farbu',
  inputDateMask_date_cleared: () => 'Dátum vymazaný',
  inputDateMask_dayPlaceholder: () => 'dd',
  inputDateMask_empty_segment: () => 'Prázdne',
  inputDateMask_monthPlaceholder: () => 'mm',
  inputDateMask_yearPlaceholder: () => 'rrrr',
  inputDatePicker_dateRangeOverflowMessageDetail: (p: { max: string }) =>
    'Zadajte dátum ' + p['max'] + ' alebo skorší.',
  inputDatePicker_dateRangeUnderflowMessageDetail: (p: { min: string }) =>
    'Zadajte dátum ' + p['min'] + ' alebo neskorší.',
  inputDatePicker_dateRestrictionMessageDetail: () => 'Zadajte dostupný dátum.',
  inputDatePicker_instruction: () => 'Na prístup ku kalendáru stlačte tabulátor.',
  inputDatePicker_selectDate: () => 'Vybrať dátum',
  inputMonthMask_dateRangeOverflowMessageDetail: (p: { max: string }) =>
    'Zadajte mesiac a rok, ktorý je ' + p['max'] + ' alebo skorší.',
  inputMonthMask_dateRangeUnderflowMessageDetail: (p: { min: string }) =>
    'Zadajte mesiac a rok, ktorý je ' + p['min'] + ' alebo neskorší.',
  inputNumber_converterParseError: () => 'Zadajte číslo.',
  inputNumber_decrease: () => 'Znížiť',
  inputNumber_increase: () => 'Zvýšiť',
  inputPassword_hidden: () => 'Skryté heslo',
  inputPassword_hide: () => 'Skryť heslo',
  inputPassword_show: () => 'Zobraziť heslo',
  inputSensitiveText_hidden: () => 'Skrytý citlivý text',
  inputTimeMask_timeRangeOverflowMessageDetail: (p: { max: string }) =>
    'Zadajte čas ' + p['max'] + ' alebo skorší.',
  inputTimeMask_timeRangeUnderflowMessageDetail: (p: { min: string }) =>
    'Zadajte čas ' + p['min'] + ' alebo neskorší.',
  inputTimeMask_time_cleared: () => 'Čas vymazania',
  labelNone: () => 'Žiadne',
  list_msgFetchCompleted: () => 'Načítané',
  list_msgFetchingData: () => 'Zavádza sa',
  list_suggestion: () => 'Návrh',
  menu_stateLoading: () => 'Zavádza sa',
  messageToast_allMessagesClosed: () => 'Všetky vyskakovacie oznámenia sú zavreté.',
  message_close: () => 'Zavrieť',
  message_confirmation: () => 'Úspešné',
  message_error: () => 'Chyba',
  message_info: () => 'Informácie',
  message_navigationFromMessagesRegion: () =>
    'Vstupujete do oblasti správ. Na navigáciu stlačte kláves F6.',
  message_navigationToMessagesRegion: () =>
    'Oblasť správ obsahuje nové správy. Na navigáciu stlačte kláves F6.',
  message_navigationToTouch: () => 'Oblasť správ obsahuje nové správy.',
  message_warning: () => 'Upozornenie',
  noData_message: () => 'Neexistujú položky na zobrazenie',
  overflowItemLabel: () => 'Ďalšie karty',
  plural_separator: () => ', ',
  popup_close_skipLink: () => 'Dvojitým ťuknutím zavrite otvorené rozbaľovacie okno.',
  popup_liveRegion_F6_initial_focus_firstFocusable: () =>
    'Vstupujete do rozbaľovacieho okna. Na navigáciu medzi rozbaľovacím oknom a súvisiacim ovládacím prvkom stlačte kláves F6.',
  popup_liveRegion_F6_initial_focus_none: () =>
    'Otvorilo sa rozbaľovacie okno. Na navigáciu medzi rozbaľovacím oknom a súvisiacim ovládacím prvkom stlačte kláves F6.',
  progressIndeterminate: () => 'Prebieha',
  radioButton_checked: () => 'Prepínač je začiarknutý',
  radioButton_selected: () => 'Prepínač je vybratý',
  radioButton_unchecked: () => 'Prepínač nie je začiarknutý',
  radioButton_unselected: () => 'Prepínač nie je vybratý',
  radio_helpForRadio: () => 'Pomoc pre prepínač',
  radio_requiredMessageDetail: () => 'Vyberte hodnotu.',
  selectMultiple_apply: () => 'Použiť',
  selectMultiple_back: () => 'Späť',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selectMultiple_highlightSelectedTagsInstructionText: () =>
    'Na zvýraznenie vybraných hodnôt použite klávesy so šípkou doľava a doprava.',
  selectMultiple_removeSelectedTagInstructionText: () =>
    'Na odobratie vybranej hodnoty stlačte klávesy Backspace alebo Delete.',
  selectMultiple_selectedValues: () => 'Vybrané hodnoty',
  selectMultiple_showSelectedValues: () => 'Zobraziť len vybrané hodnoty.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    'Počet vybraných hodnôt: ' + p['VALUE_COUNT'] + '.',
  select_addToList: () => 'Pridať do zoznamu',
  select_addToListAvailable: () => 'K dispozícii je pridanie do zoznamu',
  select_closeDropdown: () => 'Zavrite stlačením klávesu Escape.',
  select_moreSearchOptions: () => 'Ďalšie voľby vyhľadávania',
  select_moreSearchOptionsAvailable: () => 'K dispozícii sú ďalšie voľby vyhľadávania',
  select_noMatchesFound: () => 'Nenašli sa žiadne zhody.',
  select_oneMatchFound: () => 'Našla sa jedna zodpovedajúca hodnota',
  select_requiredMessageDetail: () => 'Vyberte hodnotu.',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) => 'Nájdené zhody: ' + p['TOTAL_SIZE'],
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    'Nájdené zhody: ' + p['TOTAL_SIZE'] + ' alebo viac',
  selectorAll_deselectAll: () => 'Zrušiť výber všetkého',
  selectorAll_selectAll: () => 'Vybrať všetko',
  selector_selected: () => 'Políčko je začiarknuté',
  selector_unselected: () => 'Políčko nie je začiarknuté',
  sheet_close: () => 'Zavrieť',
  switch_off: () => 'Vyp.',
  switch_on: () => 'Zap.',
  tabBarNavigationList_removeCueText: () => 'Možno odobrať',
  tabBar_tabContainsErrors: () => 'Obsahuje chyby',
  tabbar_accAnnounceRemovedKey: (p: { itemKey: string }) => 'Odstránila sa ' + p['itemKey'],
  tabbar_labelContextMenu: () => 'má kontextovú ponuku',
  tabbar_labelMoveLeft: () => 'Presunúť doľava',
  tabbar_labelMoveRight: () => 'Presunúť doprava',
  tabbar_labelRemove: () => 'Odobrať',
  timeComponent_tooltipZoomIn: () => 'Priblížiť',
  timeComponent_tooltipZoomOut: () => 'Oddialiť',
  timeConverter_parseError: () => 'Zadajte čas dokončenia.',
  train_current: () => 'Aktuálny',
  train_message_type: () => 'Typ hlásenia',
  train_not_visited: () => 'Nenavštívený',
  train_status: (p: { currentStep: string; numberOfSteps: string }) =>
    'Krok ' + p['currentStep'] + ' z ' + p['numberOfSteps'],
  train_visited: () => 'Navštívený',
  userAssistance_learnMore: () => 'Ďalšie informácie',
  userAssistance_required: () => 'Povinné',
  vis_clearSelection: () => 'Vymazať výber',
  vis_drillable: () => 'Možno použiť funkciu prechodu',
  vis_invalidData: () => 'Neplatné dáta',
  vis_labelAndValue: (p: { LABEL: string; VALUE: string }) => p['LABEL'] + ': ' + p['VALUE'],
  vis_labelCountWithTotal: (p: { itemCount: string; totalCount: string }) =>
    p['itemCount'] + ' z ' + p['totalCount'],
  vis_marqueeSelectTooltip: () => 'Pohybujúci sa text - výber',
  vis_marqueeZoomTooltip: () => 'Pohybujúci sa text - priblíženie',
  vis_noData: () => 'Žiadne dáta na zobrazenie',
  vis_panTooltip: () => 'Posunutie',
  vis_stateCollapsed: () => 'Zbalené',
  vis_stateExpanded: () => 'Rozbalené',
  vis_stateLoaded: () => 'Načítané',
  vis_stateLoading: () => 'Zavádza sa',
  vis_stateSelected: () => 'Vybrané',
  vis_stateUnselected: () => 'Nevybrané',
  warn: () => 'Upozornenie'
};
export default bundle;
